import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';
import type { GenericStatusId } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const SectionTemplatePage_OneSectionTemplate_QueryDocument = graphql(`
  query SectionTemplatePage_OneSectionTemplate_Query($id: Id!) {
    findOneSectionTemplate(id: $id) {
      _id
      codingConfig {
        kind
        strategyId
        ... on CodingConfigManual {
          code
        }
        ...CodeCmp_CodingConfig_Fragment
      }
      code
      label
      typeId
      creatorId
      updaterId
      createdAt
      updatedAt
      contentUpdatedAt
      statusId
      printing {
        pdfPrints {
          _id
          increment
          file {
            _id
            uri
          }
          isTmp
          createdAt
          creatorId
          automaticMemo
          internalMemo
          memo
        }
        pdfPrintsIncrement
      }
      virtualRoot {
        _id
        template {
          _id
          type
        }
        contentOriginId
        isVirtual
        hasPagebreakBefore
        hasPagebreakAfter
        title
        content
        orientation
        paperFormat
        isInsertionPoint
        customLayouts {
          _id
          sectionId
          orientation
          paperFormat
          hasPagebreakAfter
          hasPagebreakBefore
        }
        displayCondition {
          mode
          resolverId
          value
        }

        subSections {
          _id
          template {
            _id
            type
          }
          contentOriginId
          isVirtual
          hasPagebreakBefore
          hasPagebreakAfter
          title
          content
          orientation
          paperFormat
          isInsertionPoint
          customLayouts {
            _id
            sectionId
            orientation
            paperFormat
            hasPagebreakAfter
            hasPagebreakBefore
          }
          displayCondition {
            mode
            resolverId
            value
          }

          subSections {
            _id
            template {
              _id
              type
            }
            contentOriginId
            isVirtual
            hasPagebreakBefore
            hasPagebreakAfter
            title
            content
            orientation
            paperFormat
            isInsertionPoint
            customLayouts {
              _id
              sectionId
              orientation
              paperFormat
              hasPagebreakAfter
              hasPagebreakBefore
            }
            displayCondition {
              mode
              resolverId
              value
            }

            subSections {
              _id
              template {
                _id
                type
              }
              contentOriginId
              isVirtual
              hasPagebreakBefore
              hasPagebreakAfter
              title
              content
              orientation
              paperFormat
              isInsertionPoint
              customLayouts {
                _id
                sectionId
                orientation
                paperFormat
                hasPagebreakAfter
                hasPagebreakBefore
              }
              displayCondition {
                mode
                resolverId
                value
              }

              subSections {
                _id
                template {
                  _id
                  type
                }
                contentOriginId
                isVirtual
                hasPagebreakBefore
                hasPagebreakAfter
                title
                content
                orientation
                paperFormat
                isInsertionPoint
                customLayouts {
                  _id
                  sectionId
                  orientation
                  paperFormat
                  hasPagebreakAfter
                  hasPagebreakBefore
                }
                displayCondition {
                  mode
                  resolverId
                  value
                }

                subSections {
                  _id
                  template {
                    _id
                    type
                  }
                  contentOriginId
                  isVirtual
                  hasPagebreakBefore
                  hasPagebreakAfter
                  title
                  content
                  orientation
                  paperFormat
                  isInsertionPoint
                  customLayouts {
                    _id
                    sectionId
                    orientation
                    paperFormat
                    hasPagebreakAfter
                    hasPagebreakBefore
                  }
                  displayCondition {
                    mode
                    resolverId
                    value
                  }

                  subSections {
                    _id
                    template {
                      _id
                      type
                    }
                    contentOriginId
                    isVirtual
                    hasPagebreakBefore
                    hasPagebreakAfter
                    title
                    content
                    orientation
                    paperFormat
                    isInsertionPoint
                    customLayouts {
                      _id
                      sectionId
                      orientation
                      paperFormat
                      hasPagebreakAfter
                      hasPagebreakBefore
                    }
                    displayCondition {
                      mode
                      resolverId
                      value
                    }

                    subSections {
                      _id
                      template {
                        _id
                        type
                      }
                      contentOriginId
                      isVirtual
                      hasPagebreakBefore
                      hasPagebreakAfter
                      title
                      content
                      orientation
                      paperFormat
                      isInsertionPoint
                      customLayouts {
                        _id
                        sectionId
                        orientation
                        paperFormat
                        hasPagebreakAfter
                        hasPagebreakBefore
                      }
                      displayCondition {
                        mode
                        resolverId
                        value
                      }

                      subSections {
                        _id
                        template {
                          _id
                          type
                        }
                        contentOriginId
                        isVirtual
                        hasPagebreakBefore
                        hasPagebreakAfter
                        title
                        content
                        orientation
                        paperFormat
                        isInsertionPoint
                        customLayouts {
                          _id
                          sectionId
                          orientation
                          paperFormat
                          hasPagebreakAfter
                          hasPagebreakBefore
                        }
                        displayCondition {
                          mode
                          resolverId
                          value
                        }

                        subSections {
                          _id
                          template {
                            _id
                            type
                          }
                          contentOriginId
                          isVirtual
                          hasPagebreakBefore
                          hasPagebreakAfter
                          title
                          content
                          orientation
                          paperFormat
                          isInsertionPoint
                          customLayouts {
                            _id
                            sectionId
                            orientation
                            paperFormat
                            hasPagebreakAfter
                            hasPagebreakBefore
                          }
                          displayCondition {
                            mode
                            resolverId
                            value
                          }

                          subSections {
                            _id
                            template {
                              _id
                              type
                            }
                            contentOriginId
                            isVirtual
                            hasPagebreakBefore
                            hasPagebreakAfter
                            title
                            content
                            orientation
                            paperFormat
                            isInsertionPoint
                            customLayouts {
                              _id
                              sectionId
                              orientation
                              paperFormat
                              hasPagebreakAfter
                              hasPagebreakBefore
                            }
                            displayCondition {
                              mode
                              resolverId
                              value
                            }

                            subSections {
                              _id
                              template {
                                _id
                                type
                              }
                              contentOriginId
                              isVirtual
                              hasPagebreakBefore
                              hasPagebreakAfter
                              title
                              content
                              orientation
                              paperFormat
                              isInsertionPoint
                              customLayouts {
                                _id
                                sectionId
                                orientation
                                paperFormat
                                hasPagebreakAfter
                                hasPagebreakBefore
                              }
                              displayCondition {
                                mode
                                resolverId
                                value
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export type SectionTemplatePage_OneSectionTemplate = Omit<
  ResultOf<
    typeof SectionTemplatePage_OneSectionTemplate_QueryDocument
  >['findOneSectionTemplate'],
  'statusId'
> &
  Readonly<{
    statusId: GenericStatusId;
  }>;

export const useFindOneSectionTemplateQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    SectionTemplatePage_OneSectionTemplate_QueryDocument,
    { id },
    { enabled: !!id },
  );
